import styled, { css } from 'styled-components';

import type { IMailSubscriptionTheme } from '@/shared/themes/types';

export const Wrapper = styled.div`
  ${({ theme }: { theme: IMailSubscriptionTheme }) => css`
    margin: 5px 20px auto;
    font-size: ${theme.fontSizes.small};
    font-weight: ${theme.fontWeight.medium};
    line-height: 19px;
  `}
`;
